export default {
      id: "icon-time-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.svg#icon-time",
      toString: function () {
        return this.url;
      }
    }